// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__7KvkY","right":"styles_right__BI_tN"};